import { Category, ResponseGetCategories } from "@CommonApi/categories";
import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { addCategoryModalAtom } from "./atoms";

export const useAddCategoryModal = () => {
  const { openModal } = useModals();
  const setData = useSetAtom(addCategoryModalAtom);

  const openAddCategoryModal = ({
    categories,
    category,
    onSaved,
  }: {
    categories: ResponseGetCategories;
    category?: Category;
    onSaved?: () => void;
  }) => {
    setData({
      categories,
      category: category,
      onSaved,
    });
    openModal("AddCategoryModal");
  };

  return { openAddCategoryModal };
};
